import { FormInitializerReturnType, numberSchema } from 'src/Configuration/validation'
import { FeedInPowerModel } from '../model'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { boolean, object } from 'yup'

const MIN_VALUE_WATT_VALUES = 0
const MIN_VALUE_PERCENTAGE_VALUES = 0
const MAX_VALUE_PERCENTAGE_VALUES = 100

/**
 *  Initializes the form for editing installation settings
 * @param model FeedInPowerModel
 * @returns initialValues and validationSchema for installation settings form
 */
export const useInstallationSettingsFormInitializer = (model: FeedInPowerModel): FormInitializerReturnType<FeedInPowerModel, FeedInPowerModel> => {
  const { t } = useCustomTranslation()
  const numberSchemaWithTranslation = numberSchema(t)
  const initialValues = model

  const validationSchema = object({
    installedPvPower: numberSchemaWithTranslation({ integer: true, min: MIN_VALUE_WATT_VALUES }).required(),
    connectedPower: numberSchemaWithTranslation({ integer: true, min: MIN_VALUE_WATT_VALUES }).required(),
    powerReduction: numberSchemaWithTranslation({ integer: true, min: MIN_VALUE_PERCENTAGE_VALUES, max: MAX_VALUE_PERCENTAGE_VALUES }).required(),
    powerReductionRelatedTo: boolean().required(),
    backupCurrent: numberSchemaWithTranslation({ integer: true, min: MIN_VALUE_WATT_VALUES }).required(),
  })

  return { initialValues, validationSchema }
}
